module.exports = __webpack_public_path__ + "static/media/16UNODC9.5e1d42c7.jpg";